module.exports = __webpack_public_path__ + "img/conceptual_link_graph.ec198d47.png";